import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/data/site";
import { MaskedLine, Corner, HeroActions, HeroStrip } from "@/components/hero/HeroParts";

const HeroBackground = ({ y }) => (
    <>
        <motion.div style={{ y }} className="absolute inset-0 -z-0">
            <img
                src={IMAGES.hero}
                alt="Lavorazione meccanica di precisione su fresatrice CNC in officina metalmeccanica a Brivio, Lecco"
                className="h-[115%] w-full object-cover"
                fetchPriority="high"
            />
        </motion.div>
        <div className="absolute inset-0 bg-gradient-to-t from-tl-dark via-tl-dark/70 to-tl-dark/40" />
        <div className="absolute inset-0 bg-gradient-to-r from-tl-dark/80 via-transparent to-transparent" />
        <Corner className="left-4 top-24 sm:left-8" />
        <Corner className="right-4 top-24 sm:right-8" />
        <Corner className="bottom-8 left-4 sm:left-8" />
        <Corner className="bottom-8 right-4 sm:right-8" />
    </>
);

export default function Hero() {
    const { scrollY } = useScroll();
    const y = useTransform(scrollY, [0, 900], [0, 180]);
    const opacity = useTransform(scrollY, [0, 600], [1, 0.35]);

    return (
        <section
            id="home"
            data-testid="hero-section"
            className="blueprint-grid relative flex min-h-[100svh] items-end overflow-hidden bg-tl-dark"
        >
            <HeroBackground y={y} />
            <motion.div style={{ opacity }} className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-24 pt-40 sm:px-6 lg:px-12">
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2, duration: 0.8 }}
                    className="mb-6 font-mono-tl text-xs uppercase tracking-[0.35em] text-tl-orange"
                    data-testid="hero-eyebrow"
                >
                    Officina meccanica — Brivio (LC)
                </motion.p>
                <h1
                    data-testid="hero-headline"
                    className="font-display text-4xl font-extrabold leading-[1.06] tracking-tight text-white sm:text-5xl lg:text-7xl"
                >
                    <MaskedLine delay={0.35}>Lavorazioni</MaskedLine>
                    <MaskedLine delay={0.47}>
                        <span className="text-outline-light">meccaniche</span>
                    </MaskedLine>
                    <MaskedLine delay={0.59}>
                        su misura<span className="text-tl-orange">.</span>
                    </MaskedLine>
                </h1>
                <motion.p
                    data-testid="hero-subheadline"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.85, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="mt-7 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg"
                >
                    Realizziamo pezzi, stampi e prototipi in ferro e alluminio, seguendo le esigenze del
                    cliente con precisione e cura.
                </motion.p>
                <HeroActions />
                <HeroStrip />
            </motion.div>
        </section>
    );
}
